import type { Sport } from '@shared/types';
import { isSportEnabled } from '@/lib/sports';

interface CategoryRailProps {
  active: Sport | 'all';
  onChange: (next: Sport | 'all') => void;
}

/**
 * Filtro horizontal de deportes (estilo "Charts / Marketplace / Create" de Roblox).
 * Permite cambiar entre las categorías: Todos, Fútbol, Béisbol, Básquetbol.
 */
const ITEMS: Array<{ id: Sport | 'all'; label: string; emoji: string }> = [
  { id: 'all', label: 'Todos', emoji: '🌐' },
  { id: 'futbol', label: 'Fútbol', emoji: '⚽' },
  { id: 'beisbol', label: 'Béisbol', emoji: '⚾' },
  { id: 'basquetbol', label: 'Básquetbol', emoji: '🏀' },
];

export const CategoryRail = ({ active, onChange }: CategoryRailProps) => (
  <nav className="flex items-center gap-2 overflow-x-auto pb-2">
    {ITEMS.filter(({ id }) => id === 'all' || isSportEnabled(id)).map(({ id, label, emoji }) => {
      const isActive = active === id;
      return (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={[
            'flex shrink-0 items-center gap-2 rounded-full border px-4 py-1.5 text-sm font-semibold transition',
            isActive
              ? 'border-accent-500 bg-accent-500/15 text-white'
              : 'border-white/10 bg-ink-800/60 text-slate-300 hover:border-white/20',
          ].join(' ')}
        >
          <span>{emoji}</span>
          {label}
        </button>
      );
    })}
  </nav>
);